<template>
    <v-card>
        <template v-slot:progress>
            <v-progress-linear absolute color="blue darken-4" height="6" indeterminate></v-progress-linear>
        </template>
        <v-dialog v-model="dPersonaCopiaModal.dialog" width="500">
            <v-card>
                <v-toolbar class="justify-end" color="purple" dark>
                    <v-spacer></v-spacer>
                    <v-btn color="purple darken-1" @click="fuPersonaCopiaUpdate" :loading="dPersonaCopiaModal.IsUpdating"><v-icon>content_copy</v-icon> Copiar Persona</v-btn>
                    <v-btn @click="dPersonaCopiaModal.dialog = false" icon dark class="ml-5" title="Cerrar"><v-icon>close</v-icon></v-btn>
                </v-toolbar>
                <v-card-text>
                    <v-autocomplete label="Centro de Producción:" v-model="dPersonaCopia_IdCentroProd"
                        :items="[{text: 'Formacion Continua', value: '16'}]"
                        filled prepend-inner-icon="dashboard"></v-autocomplete>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-img height="80" src="https://cdn.vuetifyjs.com/images/parallax/material.jpg">
            <v-row class="pa-4" align="center" justify="center">
                <v-col fluid>
                    <v-list-item-avatar color="blue-grey lighten-1" size="40" class="ma-0">
                        <v-icon size="30">person_add_alt_1</v-icon>
                    </v-list-item-avatar>
                    <span class="headline black--text ma-4">Visitante</span>
                    <v-btn @click="$router.push(`/VisitanteAdd`);" color="primary"><v-icon>add</v-icon> Agregar</v-btn>
                </v-col>
            </v-row>
        </v-img>
        <v-form ref="refMain">
            <v-container fluid>
                <v-row dense>
                    <v-col cols="9" xm="12" sm="6" md="6" class="pa-1">
                        <v-text-field @keyup.enter="fuSearch" v-model="dDNINombre" label="DNI o Nombre" outlined prepend-inner-icon="credit_card" clearable :rules="[v => !!v || 'El campo es requerido']" :maxlength="120" counter autocomplete="off"></v-text-field>
                    </v-col>
                    <v-col cols="3">
                        <v-btn @click="fuSearch" :loading="dTable.loading" color="blue-grey" dark x-large>
                            <v-icon large left>search</v-icon>
                            Buscar por {{campoTipo}}
                        </v-btn>
                    </v-col>
                </v-row>
            </v-container>
        </v-form>
        <v-data-table :headers="dTable.headers" :items="dAdmvisitas" :loading="dTable.loading" :search="dTable.search" class="elevation-1">
            <template v-slot:no-data><v-alert :value="true" color="warning" icon="warning">No hay registros para mostrar.</v-alert></template>
            <template v-slot:no-results><v-alert :value="true" color="warning" icon="warning">No se encontro ningun registro con su busqueda "{{ dTable.search }}".</v-alert></template>
            <template v-slot:[`item.actions`]="{ item }">
                <v-menu bottom offset-y>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn icon v-bind="attrs" v-on="on"><v-icon>more_vert</v-icon></v-btn>
                    </template>
                    <v-list>
                        <v-list-item>
                            <v-list-item-title><v-btn @click="$router.push(`/Admision/${item.idVisitas}/Postulante`);" color="primary" block><v-icon>star</v-icon> A Postulante</v-btn></v-list-item-title>
                        </v-list-item>
                        <!-- <v-list-item>
                            <v-list-item-title><v-btn @click="fuPagoEnLinea(item.idVisitas)" color="orange" block dark><v-icon>attach_money</v-icon> Pago en Linea</v-btn></v-list-item-title>
                        </v-list-item> -->
                        <v-list-item>
                            <v-list-item-title><v-btn @click="fuPersonaCopia(item.idVisitas)" color="purple" block dark><v-icon>content_copy</v-icon> Copiar Persona</v-btn></v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu>
            </template>
            <template v-slot:[`item.prialumnos`]="{ item }">
                <template v-if="item.prialumnos.length>0" >
                    <span v-for="element in item.prialumnos" :key="element.Codigo">
                        <v-chip color="primary" dark>{{element.Codigo}}</v-chip>
                    </span>
                </template>
            </template>
        </v-data-table>
        <v-snackbar v-model="dSnackbar" color="red">Revise el formulario, existe datos erróneos.
            <v-btn text @click="dSnackbar = false"> Cerrar </v-btn>
        </v-snackbar>
    </v-card>    
</template>

<script>
import gql from 'graphql-tag';
import 'sweetalert2/src/sweetalert2.scss';
import Swal from 'sweetalert2/dist/sweetalert2.js';

export default {
    name: 'Visitante',
    data: () => ({
        dSnackbar: false,
        dAdmvisita: null,// null, 60640
        dAdmvisitas: [],
        dDNINombre:'', // 73767473
        dPersonaCopia_IdCentroProd: '16',
        dPersonaCopiaModal: {
            dialog: false, //false
            IsUpdating: false
        },
        dCopiarPersonaDialog: true,
        dTable: {
            headers: [
                {value: 'actions', text: '...', sortable: false},
                {value: 'idVisitas', text: 'idVisitas', align: ' d-none'},
                {value: 'Visitante', text: 'Visitante'},
                {value: 'Dni', text: 'DNI', align: 'center', sortable: false},
                {value: 'Celular', text: 'Celular', align: 'center', sortable: false},
                {value: 'Direccion', text: 'Direccion', sortable: false},
                {value: 'Periodo', text: 'Periodo', align: 'center'},
                {value: 'NombresPA', text: 'Nombre Apoderado', align: 'center', sortable: false},
                {value: 'FecReg', text: 'Fecha Visita', align: 'center'},
                {value: 'Operador', text: 'Operador', align: 'center'},
                {value: 'prialumnos', text: 'Alumno'}
            ],
            loading: false,
            search: null,
        }
    }),
    methods: {
        fuSearch(){
            if(this.dDNINombre==''){
                this.dSnackbar = true;
            } else {
                if(this.dDNINombre.length==8 && !isNaN(this.dDNINombre))
                    this.fuAdmvisitaByDni(this.dDNINombre)
                else
                    this.fuadmvisitasByVisitante(this.dDNINombre)
            }
        },
        async fuadmvisitasByVisitante(pVisitante) {
            this.dTable.loading = true;
            try {
                const response = await this.$apollo.query({
                    query: gql`query ($Visitante: String!){
                        admvisitasByVisitante(Visitante: $Visitante){
                            idVisitas
                            Visitante
                            Dni
                            Celular
                            Direccion
                            Periodo
                            NombresPA
                            FecReg
                            Operador
                            prialumnos{
                                Codigo
                            }
                        }
                    }`,
                    variables: {
                        Visitante: pVisitante
                    }
                });
                this.dAdmvisitas = response.data.admvisitasByVisitante;
            } catch (error) {
                console.log(error);
            } finally {
                this.dTable.loading = false
            }
        },
        async fuAdmvisitaByDni(pDni) {
            this.dTable.loading = true;
            try {
                const response = await this.$apollo.query({
                    query: gql`query admvisitaByDni($Dni: String!){
                        admvisitaByDni(Dni: $Dni){
                            idVisitas
                            Visitante
                            Dni
                            Celular
                            Direccion
                            Periodo
                            NombresPA
                            FecReg
                            Operador
                            prialumnos{
                                Codigo
                            }
                        }
                    }`,
                    variables: {
                        Dni: pDni
                    }
                })
                console.log(response.data.admvisitaByDni);
                this.dAdmvisitas = response.data.admvisitaByDni;
            } catch (error) {
                console.log(error);
            } finally {
                this.dTable.loading = false
            }
        },
        fuPagoEnLinea(pId){
            let vRandom = new Date().toISOString();
            let vUrl = "https://ifra-pago.khipu.plus/ResumenPagos/0/"+pId+"/"+vRandom;
            //let vUrl = "http://api-academico.khipu.edu.pe/ResumenPagos/0/"+pId+"/"+vRandom;
            window.open(vUrl, '_blank');
        },
        fuPersonaCopia(pId){
            this.dAdmvisita= pId;
            this.dPersonaCopiaModal.dialog = true;
        },
        async fuPersonaCopiaUpdate(){
            try {
                this.dPersonaCopiaModal.IsUpdating = true;

                const response = await this.$apollo.mutate({
                    mutation: gql`mutation admvisitaPersonaCopia($idVisitas: ID!){
                        admvisitaPersonaCopia(idVisitas: $idVisitas){
                            success
                            message
                            data
                        }
                    }`,
                    variables: {
                        idVisitas: parseInt(this.dAdmvisita)
                    }
                });
                console.log(response.data.admvisitaPersonaCopia);
                if(response.data.admvisitaPersonaCopia.success=="1"){
                    this.dPersonaCopiaModal.dialog = false;
                    Swal.fire('Correcto', response.data.admvisitaPersonaCopia.message, 'success');
                } else {
                    Swal.fire('¡ ERROR !', response.data.admvisitaPersonaCopia.message, 'error');
                }
            } catch (error) {
                console.log(error);
                Swal.fire('¡ ERROR !', 'No se registró..', 'error');
            } finally {
                this.dPersonaCopiaModal.IsUpdating = false;
            }
        },
    },
    computed: {
        campoTipo: function () {
            if(this.dDNINombre==''){
                return '';
            } else {
                if(this.dDNINombre.length==8 && !isNaN(this.dDNINombre))
                    return 'DNI';
                else{
                    if(this.dDNINombre.length==9 && !isNaN(this.dDNINombre.substring(0,5)))
                        return 'Codigo';
                    else
                        return 'Nombre';
                }
            }
        }
    }
}
</script>